<template>
  <div>
    <div class="form-group">
      <label class="">VOTRE E-MAIL PERSONNEL</label>
      <input
        class="form-control form-control-solid h-auto p-4"
        type="text"
        name="email"
        autocomplete="off"
        v-model="email"
      />
    </div>
    <div id="emailUIR" style="display: none">
      <span style="color: red">
        Veuillez réinitialiser votre mot de passe d'adresse e-mail UIR sur le
        site officiel de Microsoft :
        <a
          href="https://passwordreset.microsoftonline.com/"
          target="_blank"
          rel="noopener noreferrer"
          >https://passwordreset.microsoftonline.com/ </a
        >.
      </span>
    </div>
    <div id="notExiste" style="display: none">
      <span style="color: red"> e-mail inccorect ou n'existe pas. </span>
    </div>
    <button
      type="submit"
      :disabled="isActive"
      @click="checkEmail()"
      class="btn btn-primary action-1 px-8 py-4 my-1"
    >
      CONFIRMER
    </button>

    <div
      class="modal fade"
      id="reset_password_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#modal_ajout_activite_header"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content p-5">
          <div class="modal-header pb-3">
            <h5 class="modal-title" id="modal_ajout_activite_header">
              CONFIRMER VOTRE E-MAIL
            </h5>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-secondary btn-circle close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" class="fas fa-times"></i>
            </button>
          </div>
          <form action="#">
            <div class="modal-body px-0 py-4">
              <div class="form-group">
                <p style="color: red">
                  Veuillez renseigner le code de verification envoyé par mail
                </p>
              </div>
              <div>
                <div class="form-group">
                  <label class="">Code Verification</label>
                  <input
                    class="form-control form-control-solid h-auto p-4"
                    type="text"
                    name="code_verification"
                    autocomplete="off"
                    v-model="code_verification"
                  />
                </div>
                <span id="code_incorrect" style="color: red; display: none">
                  code confirmation incorrect
                </span>
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="resetPassword()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                CONFIRMER
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      email: "",
      code_verification: "",
      isActive: true,
    };
  },
  watch: {
    email(newEmail, oldEmail) {
      var x = document.getElementById("emailUIR");

      if (newEmail.includes("uir.ac.ma")) {
        x.style.display = "block";
        this.isActive = true;
      } else {
        x.style.display = "none";
        this.isActive = false;
      }

      if (newEmail.length == 0) {
        this.isActive = true;
      }
    },
  },
  methods: {
    checkEmail() {
      axios
        .post("/api/check/email", {
          email: this.email,
        })
        .then((response) => {
          var n = document.getElementById("notExiste");
          if (response.data == false) {
            n.style.display = "block";
          } else {
            n.style.display = "none";
            $("#reset_password_modal").modal("show");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetPassword() {
      axios
        .put("/api/reset/password", {
          email: this.email,
          code_verification: this.code_verification,
        })
        .then((response) => {
          var c = document.getElementById("code_incorrect");
          if (response.data == false) {
            c.style.display = "block";
          } else {
            $("#reset_password_modal").modal("hide");
            Vue.swal
              .fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                title:
                  "Votre mot de passe a été réinitialisé avec succès et sera envoyé à votre adresse e-mail.!",
                icon: "success",
                confirmButtonText: "Cool",
              })
              .then(function () {
                setInterval((window.location.href = "/"), 50000);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {},
};
</script>

<style>
</style>
